import destinationsUIStore from './destinationsUIStore.js';
import destinationsDataStore from './destinationsDataStore.js';

export default {
  modules: {
    ui: destinationsUIStore,
    data: destinationsDataStore,
  },
};
